/** Schema version for values stored through the connect discovery cache. */
export const HONUA_CONNECT_DISCOVERY_SNAPSHOT_VERSION = 7 as const;
/** Adapter version used to invalidate logical discovery identities. */
export const HONUA_CONNECT_ADAPTER_VERSION = "honua-connect@7";
/** Normalized facade projection version used to invalidate cached snapshots. */
export const HONUA_CONNECT_PROJECTION_VERSION = "honua-connect-source-descriptor@3";
